import URLConfig from '@Config/urls/url.config';
import * as FraudManagementModule from '@Modules/fraudManagement/pages';
import { Route } from "react-router-dom";

const URL = URLConfig.FRAUD_MANAGEMENT;

const FraudManagementRoutes = [
  // Global Settings Menu Routes
  <Route
    path={URL.GLOBAL_SETTINGS_MENU.MCC_RISK}
    element={<FraudManagementModule.MCCRiskPage />}
  />,
  <Route
    path={URL.GLOBAL_SETTINGS_MENU.COUNTRY_RISK}
    element={<FraudManagementModule.CountryRiskPage />}
  />,
  <Route
    path={URL.GLOBAL_SETTINGS_MENU.MCC_RISK_GROUP}
    element={<FraudManagementModule.MCCRiskGroupPage />}
  />,
  // Global Settings ==> Emitter Sub-Menu Routes
  <Route
    path={URL.GLOBAL_SETTINGS_MENU.GLOBAL_SETTINGS_EMITTER_MENU.RULES}
    element={<FraudManagementModule.RulesPage />}
  />,
  <Route
    path={URL.GLOBAL_SETTINGS_MENU.GLOBAL_SETTINGS_EMITTER_MENU.RULES_MANAGEMENT}
    element={<FraudManagementModule.RulesManagementPage />}
  />,
  <Route
    path={URL.GLOBAL_SETTINGS_MENU.GLOBAL_SETTINGS_EMITTER_MENU.MOVING_RULES}
    element={<FraudManagementModule.MovingRulesPage />}
  />,
  // Global Settings ==> Emitter ==> Others rules Sub-Menu Routes
  <Route
    path={URL.GLOBAL_SETTINGS_MENU.GLOBAL_SETTINGS_EMITTER_MENU.OTHER_RULES_MENU.TRIALS_AUTHORIZATION_REJECTED}
    element={<FraudManagementModule.TrialsAuthorizationRejectedPage />}
  />,
  <Route
    path={URL.GLOBAL_SETTINGS_MENU.GLOBAL_SETTINGS_EMITTER_MENU.OTHER_RULES_MENU.AVAILABLE_TO_SPEND}
    element={<FraudManagementModule.AvailableToSpendPage />}
  />,

  // Emitter Menu Routes
  <Route
    path={URL.EMITTER_MENU.LIST_OF_BROKEN_RULES}
    element={<FraudManagementModule.ListOfBrokenRulesPage />}
  />,
  <Route
    path={URL.EMITTER_MENU.LIST_OF_SUSPECT_CARDS}
    element={<FraudManagementModule.ListOfSuspectCardsPage />}
  />,
  <Route
    path={URL.EMITTER_MENU.LIST_OF_SUSPECT_TRANSACTIONS}
    element={<FraudManagementModule.ListOfSuspectTransactionPage />}
  />,
  <Route
    path={URL.EMITTER_MENU.HOLDER_REFERENTIAL_VALUE}
    element={<FraudManagementModule.HolderReferentialValuesPage />}
  />,
  <Route
    path={URL.EMITTER_MENU.LIST_OF_CARDS_BY_BROKEN_RULE + ':idRule/'}
    element={<FraudManagementModule.ListOfCardsByBrokenRulePage />}
  />,
  <Route
    path={URL.EMITTER_MENU.LIST_OF_BROKEN_RULES_BY_CARD + ':cardNumId/'}
    element={<FraudManagementModule.ListOfBrokenRulesByCardPage />}
  />,

];

export default FraudManagementRoutes;
